var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header shadow"},[_c('a',{staticClass:"home-item",on:{"click":_vm.clickLinkHome}},[_c('i',{staticClass:"fa fa-home icon"})]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('UserDropdown')],1)}
var staticRenderFns = []

export { render, staticRenderFns }